import React from 'react'

const formatDate = (value) => {
    if (!value) return null
    const d = new Date(value)
    if (isNaN(d.getTime())) return null
    return d.toLocaleDateString('en-SG', { day: 'numeric', month: 'long', year: 'numeric' })
}

/**
 * Named byline with published / updated dates and a correction contact.
 * These are the credibility signals shared by the pages currently ranking for
 * Singapore personal trainer pricing queries.
 *
 * Split into two variants so the top of the article stays compact and the
 * answer to the search query is not pushed below the fold:
 *   variant="header" - name, role and dates only (renders above the opening H2)
 *   variant="footer" - author bio and correction contact (renders after the FAQs)
 * This mirrors how the currently ranking competitor pages handle authorship.
 */
export const ArticleByline = ({ author, publishedDate, modifiedDate, variant = 'header' }) => {
    if (!author) return null

    if (variant === 'footer') {
        if (!author.bio && !author.email) return null

        return (
            <div className="border-t border-white/10 pt-5 mt-8">
                <p className="text-xs font-semibold uppercase tracking-wide text-white/40 mb-2">About the author</p>
                <div className="flex items-center gap-3 mb-2">
                    <span className="inline-flex items-center justify-center w-8 h-8 rounded-full bg-orange-500/15 text-orange-400 font-bold shrink-0">
                        {author.name.charAt(0)}
                    </span>
                    <span className="text-sm text-white/80 font-semibold">{author.name}</span>
                </div>
                {author.bio && (
                    <p className="text-xs text-white/40 leading-relaxed">{author.bio}</p>
                )}
                {author.email && (
                    <p className="text-xs text-white/30 mt-2">
                        Spotted an error in this guide?{' '}
                        <a href={`mailto:${author.email}`} className="text-orange-400/70 hover:text-orange-400 underline">
                            Email {author.email}
                        </a>{' '}
                        and we will review it.
                    </p>
                )}
            </div>
        )
    }

    const published = formatDate(publishedDate)
    const updated = formatDate(modifiedDate)

    return (
        <div className="border-y border-white/10 py-3 my-5">
            {/* <div className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm">
                <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-orange-500/15 text-orange-400 text-xs font-bold shrink-0">
                    {author.name.charAt(0)}
                </span>
                <span className="text-white/80 font-semibold">{author.name}</span>
                {author.jobTitle && (
                    <>
                        <span className="text-white/20" aria-hidden="true">·</span>
                        <span className="text-white/40">{author.jobTitle}</span>
                    </>
                )}
            </div> */}
            {(published || updated) && (
                <p className="text-xs text-white/40 mt-1.5">
                    {published && <span>Published {published}</span>}
                    {published && updated && <span className="text-white/20" aria-hidden="true"> · </span>}
                    {updated && <span>Last updated {updated}</span>}
                </p>
            )}
        </div>
    )
}
